import React, { useContext } from "react";
import classNames from "classnames";
import { GetCounterpartiesResponseDto } from "../../../common/dto/counterparty/get-counterparties-response.dto";
import { NoCounterpartyStatsResponse } from "../../../common/contracts/counterparty.contract";
import { CounterpartyDirection } from "../../../common/helpers/counterparties";
import { GridTable } from "../../general/Tables/GridTable/GridTable";
import { CounterpartiesList } from "./CounterpartiesList";
import { NoCounterpartyStats } from "./NoCounterpartyStats";
import { DirectoryContext } from "./Directory.context";
import styles from "./DirectoryTable.module.scss";

interface Props {
    counterpartiesData?: GetCounterpartiesResponseDto;
    noCounterpartyData?: NoCounterpartyStatsResponse;
    counterpartiesLoading: boolean;
    noCounterpartyLoading: boolean;
    noCounterpartyTransactionsCount?: number;
}

export const DirectoryTable: React.FC<Props> = ({
    counterpartiesData,
    noCounterpartyData,
    counterpartiesLoading,
    noCounterpartyLoading,
    noCounterpartyTransactionsCount,
}) => {
    const { counterpartyDirection } = useContext(DirectoryContext);

    const showRevenue =
        !counterpartyDirection ||
        counterpartyDirection === CounterpartyDirection.CUSTOMER;
    const showSpend =
        !counterpartyDirection ||
        counterpartyDirection === CounterpartyDirection.VENDOR;

    return (
        <GridTable
            className={classNames(styles.table, {
                [styles.allTable]: !counterpartyDirection,
                [styles.customersTable]:
                    counterpartyDirection === CounterpartyDirection.CUSTOMER,
                [styles.vendorsTable]:
                    counterpartyDirection === CounterpartyDirection.VENDOR,
            })}
            highlightRowOnHover
            noBorder
        >
            <CounterpartiesList
                data={counterpartiesData?.data}
                isLoading={counterpartiesLoading}
                showRevenue={showRevenue}
                showSpend={showSpend}
            />

            <NoCounterpartyStats
                transactionsCount={noCounterpartyTransactionsCount}
                stats={noCounterpartyData?.stats}
                isLoading={noCounterpartyLoading}
                showRevenue={showRevenue}
                showSpend={showSpend}
            />
        </GridTable>
    );
};
